module.exports = __webpack_public_path__ + "media/partners/kelloggs-8ad4c48e.svg";